import React from 'react';
import {Layout, Row, Col, Button, Divider, Tooltip, Collapse} from "antd";
import {Content} from "antd/es/layout/layout";
import './style.scss'
import {FeatureText, QAText} from "./text";
import {ReactComponent as TickIcon} from "./Tick icon.svg"
import {ReactComponent as InfoIcon} from "./Information icon.svg"
import {PlusOutlined} from "@ant-design/icons";
import {PRODUCT_TEXT} from "../../text";
import unlock_img from './Cafe_01 1.png'

const {Panel} = Collapse;


const ProSubPage = (props) => {
    return (
        <Layout>
            <Content>
                <Row className={'pro-bg-color sub-head-row'} justify={'center'}>
                    <p className={'sub-title'}>Pick the plan that’s right for you</p>
                    <p className={'sub-txt'}>
                        Start your Vieunite Pro journey with plans built for businesses big and small.
                    </p>
                    <p className={'sub-txt'} style={{margin: '-3vh 0 8vh 0'}}>
                        If you are unsure of the plan right for you can call us on 0123 456780.
                    </p>
                </Row>
                <Row className={'pro-bg-color'}
                     justify={"center"}
                     style={{
                         columnGap: '2rem',
                         padding: '0 0 3rem 0'
                     }}
                >
                    <Col className={'sub-option'} lg={6}>
                        <p className={'sub-opt-title'}>Basic</p>
                        <p className={'sub-opt-subtitle'}>Free</p>
                        <p className={'sub-opt-per-year'} style={{color: "white"}}>per year</p>
                        <Button className={'sub-opt-btn'}
                                onClick={_ => window.location.href = '/business/shopping'}
                        >
                            Buy Now
                        </Button>
                        <p className={'sub-opt-small-title'}>Standard features:</p>
                        {FeatureText['Basic'].map((txtList, idx) => {
                            return (
                                <div>
                                    <div className={'sub-features-div'}>
                                        <span className={'sub-features-inner'}><TickIcon/>{txtList[0]}</span>
                                        <Tooltip title={txtList[1]}><InfoIcon/></Tooltip>
                                    </div>
                                    <Divider style={{
                                        marginTop: '-0.3vh'
                                    }}/>
                                </div>
                            )
                        })}
                    </Col>
                    <Col className={'sub-option'} lg={6}>
                        <div className={'sub-most-popular'}>
                            Most popular
                        </div>
                        <p className={'sub-opt-title'}>Advanced</p>
                        <p className={'sub-opt-subtitle'}>£100.00</p>
                        <p className={'sub-opt-per-year'}>per year</p>
                        <Button className={'sub-opt-btn'}
                                onClick={_ => window.location.href = '/business/shopping'}
                        >
                            Buy Now
                        </Button>
                        <p className={'sub-opt-small-title'}>Intermediate features:</p>
                        {FeatureText['Advanced'].map((txtList, idx) => {
                            return (
                                <div>
                                    <div className={'sub-features-div'}>
                                        <span className={'sub-features-inner'}><TickIcon/>{txtList[0]}</span><InfoIcon/>
                                    </div>
                                    <Divider style={{
                                        marginTop: '-0.3vh'
                                    }}/>
                                </div>

                            )
                        })}
                    </Col>
                    <Col className={'sub-option'} lg={6}>
                        <p className={'sub-opt-title'}>Premium</p>
                        <p className={'sub-opt-subtitle'}>POA</p>
                        <p className={'sub-opt-per-year'}>per year</p>
                        <Button className={'sub-opt-btn'}
                                onClick={_ => window.location.href = '/business/shopping'}
                        >
                            Buy Now
                        </Button>
                        <p className={'sub-opt-small-title'}>Advanced features:</p>
                        {FeatureText['Premium'].map((txtList, idx) => {
                            return (
                                <div>
                                    <div className={'sub-features-div'}>
                                        <span className={'sub-features-inner'}><TickIcon/>{txtList[0]}</span><InfoIcon/>
                                    </div>
                                    <Divider style={{
                                        marginTop: '-0.3vh'
                                    }}/>
                                </div>
                            )
                        })}
                    </Col>
                </Row>
                <Row justify={"center"} style={{
                    backgroundColor: '#f4f4f4',
                    padding: '0 0 2rem 0'
                }}>
                    <p className={'sub-text-under'}>
                        When opting for the Vieunite Pro Standard package, a 12 month subscription fee of £100 will need
                        to be paid at checkout. Your subscription is per Textura digital canvas and will automatically
                        renew every 12 months until we are notified by you that you no longer wish to subscribe.
                    </p>
                </Row>
                <Row justify={"center"} style={{
                    // margin:'8rem 0 8rem 0',
                    backgroundColor: '#f4f4f4',
                }}>
                    <Col lg={12}
                         style={{
                             backgroundColor: "white",
                             display: "flex",
                             flexDirection: "column",
                             alignItems:'flex-end',
                             justifyContent:"center",
                         }}
                    >
                        <p className={'z-h1'}>Unlock a world of art</p>
                        <p className={'z-txt'}>
                            Vieunite Pro delivers stunning curated art to businesses through one easy to use portal
                        </p>
                        <Button
                            className={'learn-more-btn'}
                            style={{}}
                            onClick={_ =>
                                window.location.href = '/business/textura-pro'}
                        >
                            Learn More
                        </Button>
                    </Col>
                    <Col lg={12}>
                        <img alt={'unlock'} src={unlock_img}/>
                    </Col>
                </Row>
                <Row justify={"center"} style={{
                    backgroundColor: '#f4f4f4',
                    color: '#f4f4f4',
                    border: "none",
                    paddingTop: '8rem'
                }}>
                    <Col span={20} lg={20} md={20}
                         style={{
                             backgroundColor: '#f4f4f4',
                             color: '#f4f4f4',
                             border: "none",
                             margin: '-4rem 0 -3rem 2rem'
                         }}
                    >
                        <p className={'qa-title'}>Frequently Asked Questions</p>
                    </Col>
                </Row>
                <Row justify={"center"}
                     style={{
                         backgroundColor: '#f4f4f4',
                     }}>
                    <Col span={20} lg={20} md={20}>
                        <Collapse expandIconPosition={"end"}
                                  bordered={false}
                                  style={{
                                      backgroundColor: '#f4f4f4',
                                      color: '#f4f4f4',
                                      border: "none"
                                  }}
                                  expandIcon={() => <PlusOutlined style={{
                                      fontSize: '24px', fontWeight: "900",
                                  }}/>}
                        >
                            {QAText.map((txt, idx) => {
                                return (
                                    <Panel header={txt[0]}
                                           style={{
                                               fontSize: '24px', fontWeight: "600",
                                           }}
                                           key={idx}>
                                        <p>{txt[1]}</p>
                                    </Panel>
                                )
                            })}
                        </Collapse>
                    </Col>
                </Row>
            </Content>
        </Layout>
    )
}

export default ProSubPage;
